module.exports = __webpack_public_path__ + "img/6.92448530.png";